// Components
import DatePicker from 'vue2-datepicker';

// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';
import { productMixins } from '@/app/mixins/modules/product-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins';

// Constants
import { STATUS_CODES, TRANSACTION_STATUS, DOG_PURCHASE_STATUS } from '@/app/constants/constants';

// Services
import dogPurchaseAPI from '@/app/services/main/dog-purchase/dog-purchase-service.js';

export default {
    name: 'DogRequestOrdersContainer',
    components: { DatePicker },
    mixins: [tableMixins, toastMessageMixins, productMixins, dateMixins],
    data() {
        const statusList = [
            {
                id: 'APPROVED',
                name: 'APPROVED',
            },
            {
                id: 'DISAPPROVED',
                name: 'DISAPPROVED',
            },
            {
                id: 'PENDING_REQUEST',
                name: 'PENDING REQUEST',
            },
            {
                id: 'CANCEL_REQUEST',
                name: 'CANCELLED REQUEST',
            },
            {
                id: 'PENDING_PAYMENT',
                name: 'PENDING PAYMENT',
            },
            {
                id: 'FOR_PICKUP',
                name: 'FOR PICKUP',
            },
            {   
                id: "REFUNDED", 
                name: "REFUNDED" },
            {
                id: 'REQUEST_FOR_REFUND',
                name: 'REQUEST FOR REFUND',
            },
            {
                id: 'PICKED_UP',
                name: 'PICKED UP',
            },
            {
                id: 'FAILED',
                name: 'FAILED',
            },
        ];
        return {
            tabs: [
                {
                    id: 'dog',
                    label: 'Applications',
                    active: true
                },
                {
                    id: 'puppy',
                    label: 'Puppies for Sale',
                    active: false
                }
            ],
            isAPILoading: false,
            statusCodesConstants: TRANSACTION_STATUS,
            // table
            theads: [
                { name: 'Customer Name', searchLabel: 'f_customerName', sortLabel: 'customerName', isDesc: false, hasSearch: true, style: null },
                { name: 'Customer Mobile Number', searchLabel: 'f_customerMobileNumber', sortLabel: 'customerMobileNumber', isDesc: false, hasSearch: true, style: null },
                { name: 'State', searchLabel: 'f_state', sortLabel: 'state', isDesc: false, hasSearch: true, style: null },
                { name: 'Breed', searchLabel: 'f_breedName', sortLabel: 'breedName', isDesc: false, hasSearch: true, style: null },
                { name: 'Breeder', searchLabel: 'f_breederName', sortLabel: 'breederName', isDesc: false, hasSearch: true, style: null },
                { name: 'Breeder Mobile Number', searchLabel: 'f_breederMobileNumber', sortLabel: 'breederMobileNumber', isDesc: false, hasSearch: true, style: null },
                { name: 'Price', searchLabel: 'f_totalPrice', sortLabel: 'totalPrice', isDesc: false, hasSearch: true, style: 'min-width: 100px' },
                { name: 'Puppy Pickup Date', searchLabel: 'f_pickupDate', sortLabel: 'pickupDate', isDesc: false, hasDate: true, style: null },
                { name: 'Status', searchLabel: 'f_status', sortLabel: 'status', isDesc: false, hasSearchableDropdown: true, optionList: statusList, style: 'min-width: 180px' },
                { name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: 'width: 170px' },
            ],
            // sorting
            desc: true,
            selectDateAdded: '',
        };
    },
    computed: {
        getActiveTab() {
            return this.tabs.find(tab => tab.active);
        },
        dogPurchasePendingRequest() {
            return this.$store.getters.getdogPurchasePendingRequestCount;
        },
        pendingPuppySellCount() {
            return this.$store.getters.getPendingPuppySellCount;
        }
    },
    created() {
        this.getTableContent();
    },
    watch: {
        selectDateAdded() {
            this.getTableContent();
        },
    },
    methods: {
        setActiveTab(id) {
            if ( id === "puppy" ) {
                this.$router.replace('/pet-purchases/puppy-selling');
            }
        },
        getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page;
            this.getDogPurchaseList({ page, limit, sortBy, desc });
        },
        getDogPurchaseList(queryParams) {
            // search filters
            if (this.columnsFilter) {
                const { 
                    f_referenceNo, 
                    f_breedName, 
                    f_customerName, 
                    f_address, 
                    f_totalPrice, 
                    f_status,
                    f_customerMobileNumber,
                    f_state,
                    f_breederMobileNumber,
                    f_breederName
                } = this.columnsFilter;
                
                if (f_customerMobileNumber) {
                    queryParams['f_customerMobileNumber'] = f_customerMobileNumber;
                }

                if (f_state) {
                    queryParams['f_state'] = f_state;
                }

                if (f_breederMobileNumber) {
                    queryParams['f_breederMobileNumber'] = f_breederMobileNumber;
                }

                if (f_breederName) {
                    queryParams['f_breederName'] = f_breederName;
                }
                
                if (f_referenceNo) {
                    queryParams['f_referenceNo'] = f_referenceNo;
                }

                if (f_breedName) {
                    queryParams['f_breedName'] = f_breedName;
                }

                if (f_customerName) {
                    queryParams['f_customerName'] = f_customerName;
                }

                if (f_address) {
                    queryParams['f_address'] = f_address;
                }

                if (f_totalPrice) {
                    queryParams['f_totalPrice'] = f_totalPrice;
                }

                if (this.selectDateAdded) {
                    queryParams['f_pickupDate'] = this.formatDate(this.selectDateAdded, 'yyyy-MM-dd HH:mm');
                }

                if (f_status) {
                    queryParams['f_status'] = f_status;
                }
            }

            this.isAPILoading = true;

            dogPurchaseAPI.getDogPurchaseList(queryParams).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.tableContent = {
                        tableData: res.data.data.map((dt) => {
                            return { ...dt, status: DOG_PURCHASE_STATUS[dt.status] };
                        }),
                        paginationData: res.data.pagination,
                    };

                    this.isAPILoading = false;
                } else {
                    this.showAPIErrorToast('Unable to fetch dog purchase list.', res);
                    this.isAPILoading = false;
                }
            });
        },
        getClassByStatus(status) {
            const { CP, R, F, RR, D } = DOG_PURCHASE_STATUS;

            switch (status) {
                case D:
                    return 'text-success';

                case RR:
                    return 'text-warning';

                case CP:
                    return 'text-warning';

                case F:
                case R:
                    return 'text-danger';

                default:
                    return 'text-primary';
            }
        },
        updateDogPurchaseStatus(orderRef, orderId, orderStatus) {
            this.$swal({
                titleText: `Mark Dog Purchase Order #${orderRef} as ${orderStatus}`,
                html: `<p style='color: #ff801e; margin: .75rem 0 .25rem 0;'>Are you sure you want to update the dog purchase order status to <strong style='color: #ff801e'>${orderStatus.toUpperCase()}</strong>?</p>`,
                confirmButtonText: 'Confirm',
                showCancelButton: true,
                cancelButtonText: 'Cancel',
                reverseButtons: true,
                showCloseButton: true
            }).then((result) => {
                if (result.value) {
                    this.isAPILoading = true;
                    const status = orderStatus === TRANSACTION_STATUS.PICKED_UP ? "PU" : "R"
                    const body = { status };

                    const { ERROR_MARK_ORDER_AS_PICKED_UP, ERROR_MARK_ORDER_AS_REFUNDED } = this.toastMessages.order();

                    const errorMessage = orderStatus === TRANSACTION_STATUS.PICKED_UP ? ERROR_MARK_ORDER_AS_PICKED_UP : ERROR_MARK_ORDER_AS_REFUNDED;

                    dogPurchaseAPI.updateDogPurchaseStatus(orderId, body).then((response) => {
                        if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                            this.getTableContent();
                            this.showCustomSuccessToast(`Successfully updated Dog Purchase Order #${orderId} status to ${orderStatus}`);
                        } else {
                            this.showAPIErrorToast(errorMessage, response);
                        }
                    });
                }
            });
        },
    },
};